<template>
  <div v-show="show" class="contain">
    <div style="display: flex;align-items: center;padding: 15px 0 20px 0">
      <div class="trapezoid"></div>
      <div style="font-size: 14px;color: #35315c">自定义规格</div>
    </div>
    <div>
      <div class="contain-item">
        <span class="left-txt">像素尺寸：</span>
        <input @input="sizeWidthChange" :style="{color: sizeWidthInputColor==='red'?'#ff0000':'#000000'}" class="input" type="text" v-model="sizeWidth" placeholder="宽" maxlength="5"></input>
        <span>x</span>
        <input @input="sizeHeightChange" :style="{color: sizeHeightInputColor==='red'?'#ff0000':'#000000'}" class="input" type="text" v-model="sizeHeight" placeholder="高" maxlength="5"></input>
        <span>px</span>
      </div>
      <div class="contain-item">
        <span class="left-txt">文件大小：</span>
        <input @input="minSizeChange" :style="{color: minSizeInputColor==='red'?'#ff0000':'#000000'}" class="input" type="text" v-model="sizeMin" placeholder="最小" maxlength="4"></input>
        <span>-</span>
        <input @input="maxSizeChange" :style="{color: maxSizeInputColor==='red'?'#ff0000':'#000000'}" class="input" type="text" v-model="sizeMax" placeholder="最大" maxlength="4"></input>
        <span>kb</span>
      </div>
      <div class="contain-item">
        <span class="left-txt">分辨率：</span>
        <input style="margin-left: 3%" class="input" id="dpi" type="text" v-model="dpi" placeholder="300" maxlength="3"></input>
        <span>dpi</span>
        <div style="width: 23%" />
      </div>

    </div>

  </div>
</template>

<script>
    export default {
        name: "CustomSizeDialog",
        props:['show'],
        data(){
            return{
                sizeWidth:'',
                sizeHeight:'',
                sizeMin:'',
                sizeMax:'',
                dpi:'',
                sizeWidthInputColor:'',
                sizeHeightInputColor:'',
                minSizeInputColor:'',
                maxSizeInputColor:'',

            }
        },
        methods:{

            sizeWidthChange(e){
                if (e.target.value!=='') {
                    if (Number(this.sizeWidth)>3000||Number(this.sizeWidth)<10) {
                        this.sizeWidthInputColor='red'
                    }else{
                        this.sizeWidthInputColor='black'
                    }
                }


            },
            sizeHeightChange(e){
                console.log(e.target.value,this.sizeHeight)
                if (e.target.value!=='') {

                    if (Number(this.sizeHeight)>3000||Number(this.sizeHeight)<10) {
                        console.log('执行')
                        this.sizeHeightInputColor='red'
                    }else{
                        this.sizeHeightInputColor='black'
                    }
                }

            },
            minSizeChange(e){
                if (e.target.value!=='') {

                    if (Number(this.sizeMin)>2048||Number(this.sizeMin)<1) {
                        this.minSizeInputColor='red'
                    }else{
                        this.minSizeInputColor='black'
                    }
                }
            },
            maxSizeChange(e){
                if (e.target.value!=='') {
                    if (Number(this.sizeMax)>2048||Number(this.sizeMax)<1) {
                        this.maxSizeInputColor='red'
                    }else{
                        this.maxSizeInputColor='black'
                    }
                }
            },
        }
    }
</script>

<style scoped>
  .contain{
    width: 35%;
    padding-bottom:15px ;
    background-color: #F5F6FA;
    border-radius: 4px;
  }
  .contain-item{
    width: 86%;
    padding:0 7% 20px 7%;
    justify-content: space-between;
    display: flex;
    align-items: center;

  }
  .contain-item>span{
    font-size: 12px;
    transform: scale(0.9);
  }
  .contain-item>.left-txt{
    color: rgba(53,49,92,0.4);
  }
  .contain-item>.right-txt{
    color: #35315C;
  }
  .trapezoid{
    width:10px;
    height:10px;
    background-color:rgba(0,0,0,0);
    border-top:4px solid rgba(0,0,0,0);
    border-right:4px solid rgba(0,0,0,0);
    border-bottom:4px solid rgba(0,0,0,0);
    border-left:4px solid #FF7BAC;
  }
  .input{
    width:23%;font-size:12px;height:30px;background-color:white;border-radius:4px;
    text-align:center;line-height:30px;border: none;outline:none;
  }
</style>
